import { render, staticRenderFns } from "./tableFees.vue?vue&type=template&id=11349228&scoped=true"
import script from "./tableFees.vue?vue&type=script&lang=js"
export * from "./tableFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11349228",
  null
  
)

export default component.exports